export default "__VITE_ASSET__BZP40NE5__"